import React, { useState } from "react";
import styles from "./PartnersContainer.module.scss";
import { Button, Tabs } from "antd";
import Paginations from "Components/UI/Pagination/Pagination";
import cn from "classnames";
import settings from "../../Assets/Partners/settings.svg";
import threeDotsIcon from "../../Assets/blackDots.svg";

const { TabPane } = Tabs;

export const PartnersContainer = () => {
  const [currentTab, setCurrentTab] = useState<string>("1");

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
  };

  return (
    <div className={styles.loads}>
      <div className={styles.loads__block}>
        <div className={styles.loads__block__header}>
          <h1>Partners</h1>
          {currentTab === "2" && (
            <Button className={styles.loads__block__header__btn}>
              + Add Broker
            </Button>
          )}
          {currentTab === "3" && (
            <Button className={styles.loads__block__header__btn}>
              + Add Company
            </Button>
          )}
        </div>
        <Tabs
          activeKey={currentTab}
          onChange={handleTabChange}
          className={styles.loads__block__tabs}
        >
          <TabPane
            tab={
              <div
                className={cn(
                  styles.loads__block__tabs__tab,
                  currentTab === "1" && styles.loads__block__tabs__tab_active
                )}
              >
                Check
              </div>
            }
            key="1"
          >
            <table className={styles.loads__table}>
              <thead>
                <tr>
                  <th className={styles.brokerName}>
                    <span>BROKER NAME(800) </span>
                    <img
                      className={styles.settingsIcon}
                      src={settings}
                      alt="settings"
                    />
                  </th>
                  <th>LOADS RECEIVED(5896)</th>
                  <th>LOADS COMPLETED(1)</th>
                  <th className={styles.brokerName}>
                    <span>DAYS FROM LAST LOAD </span>
                    <img
                      className={styles.settingsIcon}
                      src={settings}
                      alt="settings"
                    />
                  </th>
                  <th>ACTION </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>(S) EXXPRESS SHIP PLUS, INC</td>
                  <td>0</td>
                  <td>0</td>
                  <td>146 (06/12/2023 15:22:19)</td>

                  <td>
                    <img src={threeDotsIcon} alt="three-dots" />
                  </td>
                </tr>

                <tr>
                  <td>(S) EXXPRESS SHIP PLUS, INC</td>
                  <td>0</td>
                  <td>0</td>
                  <td>146 (06/12/2023 15:22:19)</td>

                  <td>
                    <img src={threeDotsIcon} alt="three-dots" />
                  </td>
                </tr>
              </tbody>
            </table>
            <Paginations link="partners" />
          </TabPane>
          <TabPane
            tab={
              <div
                className={cn(
                  styles.loads__block__tabs__tab,
                  currentTab === "2" && styles.loads__block__tabs__tab_active
                )}
              >
                Brokers
              </div>
            }
            key="2"
          >
            <table className={styles.loads__table}>
              <thead>
                <tr>
                  <th className={styles.brokerName}>
                    <span>BROKER NAME </span>
                  </th>
                  <th>EMAIL</th>
                  <th>PHONE</th>
                  <th>MC</th>
                  <th>DOT</th>
                  <th>ADDRESS</th>
                  <th>CREDIT </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>ADADSDSDSDSDS</td>
                  <td>-</td>
                  <td>121212121</td>
                  <td>233333333</td>
                  <td>121231232</td>
                  <td>843 SOUTH DSDSDSDSDS, DSDSDSD</td>
                  <td>
                    <p className={styles.loads__block__tabs__status__callOffice}>
                      Call office
                    </p>
                  </td>
                  <td>
                    <img src={threeDotsIcon} alt="three-dots" />
                  </td>
                </tr>

                <tr>
                  <td>ADADSDSDSDSDS</td>
                  <td>-</td>
                  <td>121212121</td>
                  <td>233333333</td>
                  <td>121231232</td>
                  <td className={styles.address}>843 SOUTH DSDSDSDSDS, DSDSDSD</td>
                  <td className={styles.credit}>
                    <p className={styles.loads__block__tabs__status}>
                      Approved
                    </p>
                  </td>
                  <td>
                    <img src={threeDotsIcon} alt="three-dots" />
                  </td>
                </tr>
              </tbody>
            </table>
            <Paginations link="myloads" />
          </TabPane>
          <TabPane
            tab={
              <div
                className={cn(
                  styles.loads__block__tabs__tab,
                  currentTab === "3" && styles.loads__block__tabs__tab_active
                )}
              >
                Non-brokers
              </div>
            }
            key="3"
          >
            <table className={styles.loads__table}>
              <thead>
                <tr>
                  <th className={styles.brokerName}>
                    <span>COMPANY NAME </span>
                  </th>
                  <th>MC</th>
                  
                  <th>CITY</th>
                  <th>ADDRESS</th>
                  <th>CREDIT </th>
                  
                </tr>
              </thead>

              
            </table>
            <p className={styles.status}>No data available</p>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
